import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Typography from '../../Generic/Typography';
import style from '../ProductCard/ProductCard-tw-styles';
import getCdnSrcset from "../../../utils/srcSetHelper"
import { getCdnImage as getImageUrl } from "../../../utils/ImageManager"
import { Button } from '../../Generic/Button';

const ProductCard = ({ data = {}, onClick }) => {
  const imageSet = (data && data.image) || '';
  const typeLabel = (data && data.category) || '';
  const title = (data && data.title) || '';
  const linkButton = (data && data.linkButton) || '';
  return (
    <div className={classNames(style.cardBorder)} onClick={() => onClick && onClick(data)}>
      <div className={classNames(style.card)}>
      <div className={style.mediaWrap}>
        {imageSet ? (
          <a href={linkButton.link}>
             <picture>
                    <source
                        srcSet={imageSet.desktopImage && imageSet.desktopImage.url}
                        media="(min-width: 1024px)"
                      />
                        <img
                          className={style.media}
                          loading={"auto"}
                          src={imageSet.smartphoneImage && imageSet.smartphoneImage.url}
                          alt={imageSet.altText}
                          />
                </picture>
            </a>
        ) : (
          <div className={style.mediaPlaceholder} />
        )}
      </div>

      <div className={style.content}>
        {typeLabel && (
          <Typography component="p" className={style.type}>
            {typeLabel}
          </Typography>
        )}

        {title && (
          <Typography component="p" className={style.title}>
            {title}
          </Typography>
        )}

        <Typography component="p" className={style.cta}>
           <Button
            to={linkButton.link}
          >
            {linkButton.linkText}
          </Button>
        </Typography>
      </div>
      </div>
    </div>
  );
};


ProductCard.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]),
  onClick: PropTypes.func,
};

ProductCard.defaultProps = {
  data: {},
  onClick: () => {},
};

export default ProductCard;
